import type { PublicKeyCredentialCreationOptionsJSON } from "@simplewebauthn/server";
import { z } from "zod";

export default {
  params: z.object({}),
  response: z.object({
    webAuthnRegistrationOptions: z.custom<PublicKeyCredentialCreationOptionsJSON>(),
  }),
};
